import home from '@/assets/images/icon_home.png';
import close from '@/assets/images/icon_close.png';
import IconButton from './IconButton';
import { useLocation } from 'react-router-dom';
import { useGoTo } from '@/routers/hooks';
import { useClose } from '@/hooks/useClose';

export default ({ className, items: [_home, ..._items] }: { className?: string; items: { name: string; href: string }[] }) => {
  const { pathname } = useLocation();
  const goTo = useGoTo();
  const { handleClick } = useClose(5);

  return (
    <div className={'fixed bottom-5 right-9 ' + className}>
      {pathname !== _home.href && (
        <>
          <IconButton icon={<img src={home} />} text={_home.name} onClick={() => goTo(_home.href)} />
          <div className='my-5 flex flex-col items-center gap-3 rounded-lg bg-white py-3'>
            {_items.map((item) => (
              <div
                className='w-[28px] cursor-pointer rounded-lg p-3 text-[14px] leading-tight data-[active=true]:bg-[#97F8E9]'
                data-active={pathname === item.href}
                key={item.href}
                onClick={() => goTo(item.href)}>
                {item.name}
              </div>
            ))}
          </div>
        </>
      )}
      <IconButton icon={<img src={close} />} text='关闭' onClick={handleClick} />
    </div>
  );
};
